

import {   useState } from "react";
import '../pages/SettingPageuser.css'
import './EditModalDam.css'
import { useGlobalContext } from "./Context";
import { useDispatch, useSelector } from "react-redux";
import {  toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import apiService from "../api/ApiService";
import { loginSuccessAllSens } from "../redux/slices/allSensorSlice";
import { useForm } from "react-hook-form";
import AddToPhotosIcon from '@mui/icons-material/AddToPhotos';
import { Close, Code, Details, ModelTraining, Sell } from "@mui/icons-material";


const AddSensor=()=>{
    const {currentSensors}=useSelector(state=>state.sensors);
    const {currentSfarm}=useSelector(state=>state.p.sFarm)
    
    const {isOpenModal,closeModalls,openModalls}=useGlobalContext();
    const {
        register,
        handleSubmit,
        formState: { errors }
      } = useForm();
    
    const dispatch=useDispatch();
    
    const AddNewSensor=async(data)=>{
            const data1=JSON.stringify({...data,farmId:currentSfarm.id})
            const res=await apiService.addNewSensor(data1);
            dispatch(loginSuccessAllSens([...currentSensors,res.data]))
            openModalls()
    }

    

    return <div onClick={closeModalls} className={`modal-overlay ${isOpenModal&&'show-modal'} `}>
        <form onSubmit={handleSubmit(AddNewSensor)} className="editModalDamCon Ani AllFFFF" >
        <div className="closee"><Close className='closee'/></div>
            <div className="editModalDamConHead">
                <AddToPhotosIcon fontSize="large"/>
            <h4 > ایجاد سنسور جدید</h4>
            </div>
       
            <div className='inputContainerSS'>
            <input autoComplete="off" type="text"  className='inputSS' placeholder="a" {...register("specs",{required:'این مقدار ضروری است'})}/>
            <label for="" className={'labelSS'}><Details fontSize="small"/> توضیحات سنسور </label>
            {errors?.specs?.message&&<span className='errMsg'>{errors.specs.message}</span>}
        </div>
        <div className='inputContainerSS'>
            <input autoComplete="off" type="number"  className='inputSS' placeholder="a" {...register("deviceCode",{required:'این مقدار ضروری است'})}/>
            <label for="" className={'labelSS'}><Code fontSize="small"/> کد سنسور </label>
            {errors?.deviceCode?.message&&<span className='errMsg'>{errors.deviceCode.message}</span>}
        </div>
        <div className='inputContainerSS'>
            <input autoComplete="off" type="number"  className='inputSS' placeholder="a" {...register("necklaceNumber",{required:'این مقدار ضروری است'})}/>
            <label for="" className={'labelSS'}><Sell fontSize='small'/> شماره گردنبند  </label>
            {errors?.necklaceNumber?.message&&<span className='errMsg'>{errors.necklaceNumber.message}</span>}
        </div>
        <div className='inputContainerSS'>
            <input autoComplete="off" type="text"  className='inputSS' placeholder="a" {...register("version",{required:'این مقدار ضروری است',pattern:{
                value:/^.{1,50}$/,
                message:'    حداکثر 50 کاراکتر'
            }})}/>
            <label for="" className={'labelSS'}><ModelTraining fontSize="small"/> ورژن   </label>
            {errors?.version?.message&&<span className='errMsg'>{errors.version.message}</span>}
        </div>
        <button className="EditMOdalBtnForm" type="submit">
            تایید
        </button>
        
        </form>
        <div style={{marginTop:'120px'}}> 
        
        </div>
        
    </div>
}
export default  AddSensor